import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Label,
} from "reactstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
const OutwardFormModal = ({
  isOpen,
  toggle,
  onSubmit,
  deliveryBoyList = [],
  remainingPieces = 0,
  initialValues = {},
  t = (v) => v,
  submitLabel = "Submit",
  cancelLabel = "Cancel",
  title = "Outward Form",
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>{t(title)}</ModalHeader>
      <ModalBody>
        <Formik
          initialValues={initialValues}
          validationSchema={Yup.object().shape({
            piecesToDeliver: Yup.number()
                          .required("Required")
                          .min(1, "Must be at least 1")
                          .test(
                            "max-return-pieces",
                            `You can only deliver up to ${remainingPieces} pieces.`,
                            function (value) {
                              return value <=  remainingPieces;
                            }
                          ),
                        totalWeight: Yup.number().required("Weight is Required"),
                        deliveryBoy: Yup.string().required("Delivery Boy is Required"),
                           })}
          onSubmit={onSubmit}
          enableReinitialize
        >
          {({ handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              {/* Remaining Pieces Display (read-only) */}
              <div className="mb-3 d-flex align-items-center">
                <Label htmlFor="remainingPieces" style={{ minWidth: 180 }}>
                  <h5 className="mb-0 fw-bold text-secondary">
                    {t("Remaining Pieces")}
                  </h5>
                </Label>
                <Field
                  type="number"
                  name="remainingPieces"
                  className="form-control w-50"
                  value={remainingPieces}
                  readOnly
                />
              </div>

              {/* Pieces to Deliver */}
              <div className="mb-3 d-flex align-items-center">
                <Label htmlFor="piecesToDeliver" style={{ minWidth: 180 }}>
                  <h5 className="mb-0 fw-bold text-secondary">
                    {t("Pieces to Deliver")}
                  </h5>
                </Label>
                <div className="w-50">
                <Field
                  type="number"
                  name="piecesToDeliver"
                  className="form-control"
                  placeholder={t("Pieces to Deliver")}
                  // min={1}
                  // max={remainingPieces}
                />
                 <ErrorMessage
                   name="piecesToDeliver"
                   component="div"
                   className="text-danger mt-1"
                />
                </div>
              </div>

              {/* Total Weight */}
              <div className="mb-3 d-flex align-items-center">
                <Label htmlFor="totalWeight" style={{ minWidth: 180 }}>
                  <h5 className="mb-0 fw-bold text-secondary">
                    {t("Total Weight")}
                  </h5>
                </Label>
                <div className="w-50">
                <Field
                  type="number"
                  name="totalWeight"
                  className="form-control"
                  placeholder={t("Total Weight")}
                />
                 <ErrorMessage
                    name="totalWeight"
                    component="div"
                    className="text-danger mt-1"
                />
                </div>
              </div>

              {/* Remark */}
              <div className="mb-3 d-flex align-items-center">
                <Label htmlFor="remark" style={{ minWidth: 180 }}>
                  <h5 className="mb-0 fw-bold text-secondary">{t("Remark")}</h5>
                </Label>
                <Field
                  as="textarea"
                  name="remark"
                  rows={3}
                  className="form-control w-50"
                  placeholder={t("Remark")}
                />
              </div>

              {/* Delivery Boy */}
              <div className="mb-3 d-flex align-items-center">
                <Label htmlFor="deliveryBoy" style={{ minWidth: 180 }}>
                  <h5 className="mb-0 fw-bold text-secondary">
                    {t("Delivery Boy")}
                  </h5>
                </Label>
                <div className="w-50">
                <Field
                  as="select"
                  name="deliveryBoy"
                  className="form-control"
                >
                  <option value="" disabled>
                    {t("Select")}
                  </option>
                  {deliveryBoyList.map((boy) => (
                    <option key={boy.id} value={boy.id}>
                      {boy.name}
                    </option>
                  ))}
                </Field>
                <ErrorMessage
                    name="deliveryBoy"
                    component="div"
                    className="text-danger mt-1"
                />
                </div>
              </div>

              {/* Footer Buttons */}
              <ModalFooter>
                <Button color="primary" type="submit">
                  {t(submitLabel)}
                </Button>
                <Button color="secondary" onClick={toggle} type="button">
                  {t(cancelLabel)}
                </Button>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </ModalBody>
    </Modal>
  );
};

export default OutwardFormModal;
